import { z } from "zod";
import { INVALID_EMAIL, REQUIRED_FIELD } from "../../../utils/constants";

export const OrganizationItemSchema = z
  .object({
    name: z.string().min(1, { message: REQUIRED_FIELD }),
    email: z
      .string()
      .optional()
      .refine(
        (value) => !value || z.string().email().safeParse(value).success,
        {
          message: INVALID_EMAIL,
        },
      ),
    organizationLevelOption: z.object({
      id: z.number(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
    }),

    provinceOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),

    countyOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data?.organizationLevelOption.id >= 4 && !data.provinceOption) {
      ctx.addIssue({
        path: ["provinceOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }

    if (data?.organizationLevelOption.id === 5 && !data.countyOption) {
      ctx.addIssue({
        path: ["countyOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
  });
